import React, { FC, useState, useEffect } from "react";
import { RouterParamType } from "@/model/navModel";
import { YhBox } from "@/components/YhBox";
import { Button } from "antd";
import "./invoice.less"
import { exportPDF } from "@/utils/exportPDF";
import { enquiryService } from "../../../dtpService";
import { IDtpDetail, IDtpMaterialDetail } from "../../../dtpTypes";
import { useDtpDetailModel } from "../dtpDetailModel";
import useGlobalModel from "@/model/globalModel";
import { customerService } from "@/views/base/customer/customerService";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum4, formatNum, momentFormat } from "@/utils/utils";
import { salesService } from "@/views/sales/salesService";

//商业发票
export const Invoice: FC<RouterParamType> = (detailsInfo) => {
    const {
        editFormVal, currency
    } = useDtpDetailModel(({ editFormVal, currency }) => [editFormVal, currency]);
    const { getTreeNodeName } = useDictModel(() => []);
    const { user: { shopCode } } = useGlobalModel(({ user }) => [user]);
    const [loading, setLoading] = useState<boolean>(false);  //导出pdf， 
    const [formVal, setFormVal] = useState<IDtpDetail | null>(null);
    const [list, setList] = useState<IDtpMaterialDetail[]>([])
    const [amountAll, setAmountAll] = useState<number>(0);
    useEffect(() => {
        getDtpDetailOne()
    }, []);

    //获取一条数据
    const getDtpDetailOne = async () => {
        let { retData } = await enquiryService.one(editFormVal.id);
        let { details, auditFlag, ...params } = retData;
        let data = {
            code: params.customerCode,
            pageNum: 1,
            pageSize: 15,
            shopCode,
        }
        let { retData: customerData } = await customerService.page(data);
        const { records, ...pg } = customerData;
        let { retData: saleData } = await salesService.one(retData.saleCode ?? "");
        setFormVal({
            ...params,
            address: records[0]?.address,
            contact: records[0]?.contact,
            email: records[0]?.email,
            phone: records[0]?.phone,
            goodsAmount: saleData?.goodsAmount,  //外贸货值金额
            addAmount: saleData?.addAmount,  //外贸附加费
            contractAmount: saleData?.contractAmount,  //外贸合同总金额
            addMethodEname: saleData?.detailsAdd?.[0]?.ename ?? ""  //外贸单加收费用的第一个英文名称
        })
        let newList = (details ?? []).map(item => ({
            ...item,
            // amount: formatNum(+(item.num ?? 0) * +(item.price ?? 0))
        }))
        setList(newList);
        setAmountAll(newList?.reduce((con, next) => { con += +(next.amount ?? 0); return con }, 0) ?? 0)
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            loading={loading}
            onClick={() => {
                setLoading(true);
                setTimeout(() => {
                    exportPDF("商业发票", "invoicePDF", () => {
                        setLoading(false);
                    })
                }, 1500);
            }}
        >导出PDF</Button>
    </>

    return (
        <YhBox title={action} style={{ marginBottom: "75px" }} >
            {formVal && <div style={{ width: "80%", margin: "10px auto" }} id="invoicePDF">
                {formVal.status === "clearance-status.effect" && <div className="seal-box"></div>}
                <h4 className="align-center">云湖春煜（天津）资产管理有限公司</h4>
                <h4 className="align-center">YUNHUCHUNYU(TIANJIN) ASSETS MANAGEMENT CO.,LTD</h4>
                <h4 className="align-center">商业发票&nbsp;&nbsp;&nbsp;&nbsp;COMMERCIAL&nbsp;&nbsp;INVOICE </h4>
                {/* 单号 */}
                <p className="align-right">Invoice No.: {formVal.invoiceNumber}</p>
                {/* 日期 */}
                <p className="align-right">Date:{momentFormat(formVal.invoiceTime as string, "YYYY-MM-DD")}</p>
                {/* 发货人 */}
                <p>SHIPPER: {formVal.supplierName}</p>
                {/* 收货人 */}
                <p>CONSIGNEE: {formVal.customerName}</p>
                {/* 地址 */}
                <p>ADD:{formVal.address}A</p>
                {/* 联系人 */}
                <p>CONTACT PERSON:{formVal.contact}</p>
                {/* 联系电话 */}
                <p>TEL:{formVal.phone}</p>
                {/* 邮箱 */}
                {/* <p className="mb-30">E-MAIL:{formVal.email}</p> */}
                <p>SHIPPING MARK：{formVal.labelNote}</p>
                <ul>
                    {/* 原产国 */}
                    {/* <li>COUNTRY OF ORIGN: {getTreeNodeName(formVal.countryTrade)}</li> */}
                    <li>COUNTRY OF ORIGN: CHINA</li>
                    {/* 供应国 */}
                    {/* <li>COUNTRY OF SUPPLY: {getTreeNodeName(formVal.destinationCountry)}</li> */}
                    <li>COUNTRY OF SUPPLY: CHINA</li>
                </ul>
                <ul>
                    {/* 发票编号 */}
                    <li>INVOICE NO: {formVal.invoiceNumber}</li>
                    {/* 发货港 */}
                    <li>PORT OF DISPATCH:{getTreeNodeName(formVal.portDeparture)}</li>
                </ul>
                <ul>
                    {/* 日期 */}
                    <li>Date: {momentFormat(formVal.invoiceTime as string, "YYYY-MM-DD")} </li>
                    {/* 目的港 */}
                    <li>PORT OF DESTINATION: {getTreeNodeName(formVal.dischargingPort)}</li>
                </ul>
                <table>
                    <tbody>
                        <tr>
                            <td>NO. <br />项目</td>
                            <td>NAME <br />商品名称</td>
                            <td>HS CODE <br />海关编码</td>
                            <td>SPECIFICATIONS <br />规格型号</td>
                            <td>QTY <br />数量</td>
                            <td>UNIT <br />单位</td>
                            <td>UNIT PRICE <br />单价</td>
                            <td>TOTAL IN {list[0]?.currency ?? ""} <br />总价（{currency}）</td>
                        </tr>
                        {
                            list && list.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <span>{item.materialName}</span>
                                        <br />
                                        <span>{item.materialEname}</span>
                                    </td>
                                    <td>{item.customsCode}</td>
                                    <td>{item.model}</td>
                                    <td>{item.num}</td>
                                    <td>{item.unitName}</td>
                                    <td>{currency}{formatNum4(item.price)}</td>
                                    <td>{currency}{item.amount}</td>
                                </tr>
                            ))
                        }
                        <>{formVal.goodsAmount == amountAll ? <>
                            <tr>
                                {/* 发货港 + 币种， 货值金额*/}
                                <td colSpan={6} style={{ textAlign: "right" }}>FOB {getTreeNodeName(formVal.portDeparture)} IN {list[0]?.currency ?? ""}</td>
                                <td colSpan={2}>{currency}{formatNum(formVal.goodsAmount)}</td>
                            </tr>
                            <tr>
                                {/* 加收费用名称 & 加收费用金额 */}
                                <td colSpan={6} style={{ textAlign: "right" }}>{formVal.addMethodEname}</td>
                                <td colSpan={2}>{currency}{formatNum(formVal.addAmount)}</td>
                            </tr>
                            <tr>
                                {/* 贸易条款 & 卸运港 & 合同总金额 */}
                                <td colSpan={6} style={{ textAlign: "right" }}>TOTAL {getTreeNodeName(formVal.transactionType)} {getTreeNodeName(formVal.dischargingPort)} AMOUNT</td>
                                <td colSpan={2}>{currency}{formatNum(formVal.contractAmount)}</td>
                            </tr>
                        </> :
                            <>
                                <tr>
                                    {/* 贸易条款 & 卸运港 & 合同总金额 */}
                                    <td colSpan={6} style={{ textAlign: "right" }}>TOTAL {getTreeNodeName(formVal.transactionType)} {getTreeNodeName(formVal.dischargingPort)} AMOUNT</td>
                                    <td colSpan={2}>{currency}{formatNum(formVal.contractAmount)}</td>
                                </tr>
                                <tr>
                                    {/* 加收费用名称 & 加收费用金额 */}
                                    <td colSpan={6} style={{ textAlign: "right" }}>{formVal.addMethodEname}</td>
                                    <td colSpan={2}>{currency}{formatNum(formVal.addAmount)}</td>
                                </tr>

                                <tr>
                                    {/* 发货港 + 币种， 货值金额*/}
                                    <td colSpan={6} style={{ textAlign: "right" }}>FOB {getTreeNodeName(formVal.portDeparture)} IN {list[0]?.currency ?? ""}</td>
                                    <td colSpan={2}>{currency}{formatNum(formVal.goodsAmount)}</td>
                                </tr>
                            </>
                        }</>
                        <tr>
                            {/* <td colSpan={8} style={{ textAlign: "right" }}>
                                SAY TOTAL {getTreeNodeName(formVal.transactionType)} {getTreeNodeName(formVal.dischargingPort)} {formVal.note} ONLY
                            </td> */}
                            <td colSpan={8} style={{ textAlign: "right" }}>
                                {formVal.note}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p className="align-right mt-20">YUNHUCHUNYU(TIANJIN) ASSETS MANAGEMENT CO.,LTD</p>
            </div>}
        </YhBox>
    )
}